import { SVGProps } from "react";

export function VerifiBadge({
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_22993_168559)">
        <path d="M15.0705 2.40039L12.9638 5.67845L6.96546 15.307L6.57073 11.2688L6.26118 6.87875H0.0622854L0 7.22518C1.59128 7.22518 2.53269 7.98417 2.79459 9.53809L3.99902 19.7742L4.00653 19.7515L4.02266 19.9016H8.2847L15.9015 5.29745L17.5012 2.40039H15.0705Z" fill="#008934" />
        <path d="M8.50213 11.3354H8.77909L14.8001 2.40039L4.37598 5.08089V5.36338L8.50213 6.86789V11.3354Z" fill="#FD853A" />
      </g>
      <defs>
        <clipPath id="clip0_22993_168559">
          <rect width="18" height="17.5012" fill="white" transform="translate(0 2.40039)" />
        </clipPath>
      </defs>
    </svg>
  );
}
